// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"f801717d","388":"d9abfc63","426":"a6b33ccb","681":"f2fdb007","798":"d9abfc63","970":"f2fdb007","982":"76b2bb78"}[chunkId] + ".chunk.css";
};